import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import ProgressComponent from '../../../components/general/ProgressComponent';
import DataTable from "react-data-table-component";
import password_eye_icon_circle from "../../../assets/images/icons/password_eye_icon_circle.svg";
import {
    BASE_URL,
} from "../../../env";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

function CarePlanHistory({ carePlanHistory }) {
    // console.log("🚀 ~ CarePlanHistory ~ carePlanHistory:", carePlanHistory)
    const navigate = useNavigate();
    // const carePlanHistoryData = carePlanHistory;

    const carePlanHistoryData = [...carePlanHistory].sort((a, b) =>
        new Date(b.modifiedTime) - new Date(a.modifiedTime)
    );
    // Table Columns
    const columns = [
        {
            name: "Modified Date - Time",
            selector: (row) => {
                return (
                    <div>
                        <span>{moment(row?.modifiedTime).format("DD/MM/YYYY / hh:mm:ss A")}</span>
                    </div>
                );
            },
            width: "22%",
        },
        {
            name: "Modified By",
            selector: (row) => {
                return (
                    <>
                        <span className="usersNameInfo">
                            <span className="userImage">
                                <img src={`${BASE_URL}${row?.modifiedUser?.profile_picture_url}`} alt={row?.modifiedUser?.name} />
                            </span>
                            <span className="userInfo">
                                <span className="nameBlock">{row?.modifiedUser?.name}</span>
                            </span>
                        </span>
                    </>
                );
            },
            wrap: true,
        },


        {
            name: "Action",
            selector: (row) => {
                return (
                    <div className="actionColumns individualReviewsActions">

                        <span className="edit" onClick={() => handleEditViewCarePlans(row, "/view-care-plan-history")}>
                            <img src={password_eye_icon_circle} alt="View" title="View" />
                        </span>

                        {/* <span className="edit" onClick={() => handleEditViewCarePlans(row, "/edit-care-plan")}>
                  <img src={editBlock} alt="Edit" title="Edit" />
                </span> */}

                        {/* <span
                  className="delete"
                  onClick={() => {
                    subModalDeleteCarePlans(row?._id);
                  }}
                >
                  <img src={eventDel} alt="Delete" title="Delete" />
                </span> */}
                    </div>
                );
            },
            width: "12%",
            center: true,
            wrap: true,
        },
    ];

    const handleEditViewCarePlans = (item, url) => {
        // console.log("🚀 ~ handleEditViewCarePlans ~ item:", item)
        localStorage.setItem(
            "carePlanHistoryDetail",
            JSON.stringify(item)
        );
        navigate(url);
    };
    return (
        <>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header><h3 className="sectionTitle">History</h3></Accordion.Header>
                    <Accordion.Body>
                        <div className="dataTableWrapper carePlanDataTableWrapper">
                            <DataTable
                                className="maxWidthTable minWidthTable"
                                columns={columns}
                                data={carePlanHistoryData}
                                highlightOnHover
                                responsive={true}
                            />
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    )
}

export default CarePlanHistory